export default "__VITE_ASSET__Dzl4_AE2__"